import(/* webpackMode: "eager" */ "/vercel/path0/web/app/error.tsx");
